import '../../../common/dashboard/filters/filter_view.js.coffee'
import '../../../common/dashboard/filters/fixed_string_filters_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedTicketAttributesFiltersView extends Common.Dashboard.Filters.FilterView
  initialize: ({filter, ticketAttributeDefinitions, isReadOnly}) ->
    _.extend(@, Common.Dashboard.Filters.FixedStringFiltersMixin)
    @filter = filter
    @isReadOnly = isReadOnly
    @attributes = ticketAttributeDefinitions
    @listenTo(@attributes, 'update', @render)
    @filterViews = []
    @lastAppliedFilter = {}

  render: =>
    @filterViews.forEach((view) -> view.remove())
    for code, values of @filter._valuesToJSON()
      @_addAttributeFilterView(code, values)
    @filterViews.forEach (view) =>
      @listenTo view, 'filter:remove', =>
        @trigger('filter:remove', (compositeFilter) =>
          @filter.removeFromCompositeFilter(compositeFilter, view.filter.getCode()))
      @listenTo view, 'filter:value:remove', ({value}) =>
        @trigger('filter:value:remove', (compositeFilter) =>
          @filter.removeValueFromCompositeFilter(compositeFilter, view.filter.getCode(), value))
      @listenTo view, 'filter:apply', (values) =>
        @lastAppliedFilter = {}
        @lastAppliedFilter[view.attributeCode()] = values
        @applyFilter()
      @$el.append(view.render().el)
    @

  _addAttributeFilterView: (code, values) ->
    attribute = @attributes.find (attribute) -> attribute.get('code') == code
    return unless attribute
    FILTER = CustomerVisualMode.Filters
    if attribute.isFixedString()
      attributeFilterView = FILTER.Applied.AppliedFixedStringFilterView
      attributeFilter = FILTER.FixedStringAttributeFilter
    if attribute.isHierarchicalTags()
      attributeFilterView = FILTER.Applied.AppliedHierarchicalTagsFilterView
      attributeFilter = FILTER.HierarchicalTagsAttributeFilter
    @filterViews.push new attributeFilterView
      filter: new attributeFilter({attribute, values: values})
      isReadOnly: @isReadOnly
